import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { EmergencyBannerContainer } from './EmergencyBanner';
import { StarterDashPromptingBanner } from './StarterDashPromptingBanner';

export const BannerContainer: React.FC = () => {
	const {
		data: { starterDashboardPromptingBannerEnabled },
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: { emergencyBannerContent: emergencyBanner },
		},
	} = usePetitionDetailsPageData();

	if (emergencyBanner) {
		return <EmergencyBannerContainer emergencyBanner={emergencyBanner} />;
	}

	if (starterDashboardPromptingBannerEnabled) {
		return <StarterDashPromptingBanner />;
	}

	return null;
};
